import { get, post } from "../GenericServices";

const ProjectInvoicePlan = {
  getDataProjectInvoicePlan: (id) => {
    return get(`project/${id}/project-invoice-plan`);
  },
  saveDataProjectInvoicePlan: (id, body) => {
    return post(`project/${id}/project-invoice-plan`, body);
  },
  saveDataProjectAdjInvoicePlan: (id, body) => {
    return post(`project/${id}/project-invoice-plan/adjustment-plan`, body);
  },
  saveDataProjectProductionPlan: (id, body) => {
    return post(`project/${id}/project-invoice-plan/adjustment`, body);
  },
  downloadProjectInvoicePlan: (id) => {
    return get(`project/${id}/project-invoice-plan/export`, {}, "arraybuffer"); // To download xlsx I must set responseType = arraybuffer);
  },
};

export default ProjectInvoicePlan;
